import {
  getContactUserListRepo,
  postContactUserPushRepo,
  postSendToNetcoreRepo,
  getSendToNetcoreRepo,
} from "../../../repositories/premium/contactUserPush";

import {
  getContactUserListLoading,
  getContactUserListSuccess,
  getContactUserListFailure,
  postContactUserPushLoading,
  postContactUserPushSuccess,
  postContactUserPushFailure,
  postSendToNetcoreLoading,
  postSendToNetcoreSuccess,
  postSendToNetcoreFailure,
  getSendToNetcoreLoading,
  getSendToNetcoreSuccess,
  getSendToNetcoreFailure,
} from "../../../slices/contactPushUser";

export const getContactUser = (params) => {
  return async (dispatch) => {
    dispatch(getContactUserListLoading());
    await getContactUserListRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getContactUserListSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getContactUserListFailure(error.message));
        }
      });
  };
};

export const postContactUserPush = (data) => {
  return async (dispatch) => {
    await postContactUserPushRepo(data)
      .then((response) => {
        if (response && (response.status == 201 || response.status == 200)) {
          dispatch(postContactUserPushSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postContactUserPushFailure(error.message));
        }
      });
  };
};

export const postSendToNetCore = (data, params) => {
  return async (dispatch) => {
    await postSendToNetcoreRepo(data, params)
      .then((response) => {
        if (response && (response.status == 201 || response.status == 200)) {
          dispatch(postSendToNetcoreSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postSendToNetcoreFailure(error.message));
        }
      });
  };
};

export const getSendToNetcore = (params) => {
  return async (dispatch) => {
    dispatch(getSendToNetcoreLoading());
    await getSendToNetcoreRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getSendToNetcoreSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getSendToNetcoreFailure(error.message));
        }
      });
  };
};